import type { DirectiveBinding } from "vue";

export const clickOutsideDirective = {
  mounted(
    el: HTMLElement & { clickOutsideEvent: (e: Event) => void },
    binding: DirectiveBinding
  ) {
    el.clickOutsideEvent = (event: Event) => {
      // Check if the click is outside the element and its children
      if (!(el === event.target || el.contains(event.target as Node))) {
        // If it is, call the method provided in the binding value
        binding.value(event);
      }
    };
    // Attach the click event listener to the document
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted(el: HTMLElement & { clickOutsideEvent: (e: Event) => void }) {
    // Remove the click event listener when the element is unmounted
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
};

// export default clickOutsideDirective;
